import { Component } from "react/cjs/react.production.min";
import { dataMain } from "../../data";
import { buttonPressed, noContextMenu } from "../../logic/DOMElementsRelated.js";
import { goToNftPath } from "../../logic/nftRelated.js";
import retrieveOwner from "../../logic/query";
import Sound from "../../logic/Sound";
import "./sekans.css";
import { SekansBonusSounds } from './SekansBonusSounds.js';
import { SekansBottomOptions } from './SekansBottomOptions.js';
import { SekansPadsCard } from './SekansPadsCard.js';
import { SekansRightOptions } from "./SekansRightOptions.js";
import { SekansSoundsIdentifier } from "./SekansSoundsIdentifier";
import { SekansStepsLights } from "./SekansStepsLights";

let playIntervale = null
export default class SekansLogic extends Component {
  constructor(props) {
    super(props)
    this.state = {
      imagesSrc: this.props.data.imagesSrc,
      playActive: false,
      mutePads: false,
      currentStep: -1,
      activePads: [
        [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false]
      ],
      activeCursor: [
        [true, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false]
      ],
      cursorPosition: [0, 0],
      stepsAmount: 16,
      soundsAmount: 6,
      padsIndexes: [
        [{row:1, col:1}, {row:1, col:2}, {row:1, col:3}, {row:1, col:4}, 
          {row:1, col:5}, {row:1, col:6}, {row:1, col:7}, {row:1, col:8},
          {row:1, col:9}, {row:1, col:10}, {row:1, col:11}, {row:1, col:12}, 
          {row:1, col:13}, {row:1, col:14}, {row:1, col:15}, {row:1, col:16}],
        [{row:2, col:1}, {row:2, col:2}, {row:2, col:3}, {row:2, col:4}, 
          {row:2, col:5}, {row:2, col:6}, {row:2, col:7}, {row:2, col:8},
          {row:2, col:9}, {row:2, col:10}, {row:2, col:11}, {row:2, col:12}, 
          {row:2, col:13}, {row:2, col:14}, {row:2, col:15}, {row:2, col:16}],
        [{row:3, col:1}, {row:3, col:2}, {row:3, col:3}, {row:3, col:4}, 
          {row:3, col:5}, {row:3, col:6}, {row:3, col:7}, {row:3, col:8},
          {row:3, col:9}, {row:3, col:10}, {row:3, col:11}, {row:3, col:12}, 
          {row:3, col:13}, {row:3, col:14}, {row:3, col:15}, {row:3, col:16}],
        [{row:4, col:1}, {row:4, col:2}, {row:4, col:3}, {row:4, col:4}, 
          {row:4, col:5}, {row:4, col:6}, {row:4, col:7}, {row:4, col:8},
          {row:4, col:9}, {row:4, col:10}, {row:4, col:11}, {row:4, col:12}, 
          {row:4, col:13}, {row:4, col:14}, {row:4, col:15}, {row:4, col:16}],
        [{row:5, col:1}, {row:5, col:2}, {row:5, col:3}, {row:5, col:4}, 
          {row:5, col:5}, {row:5, col:6}, {row:5, col:7}, {row:5, col:8},
          {row:5, col:9}, {row:5, col:10}, {row:5, col:11}, {row:5, col:12}, 
          {row:5, col:13}, {row:5, col:14}, {row:5, col:15}, {row:5, col:16}],
        [{row:6, col:1}, {row:6, col:2}, {row:6, col:3}, {row:6, col:4}, 
          {row:6, col:5}, {row:6, col:6}, {row:6, col:7}, {row:6, col:8},
          {row:6, col:9}, {row:6, col:10}, {row:6, col:11}, {row:6, col:12}, 
          {row:6, col:13}, {row:6, col:14}, {row:6, col:15}, {row:6, col:16}]
      ],
      soundsIdentifiersImages: [this.props.data.imagesSrc[1], this.props.data.imagesSrc[2],this.props.data.imagesSrc[3], this.props.data.imagesSrc[4],this.props.data.imagesSrc[5], this.props.data.imagesSrc[6]],
      cursorPadActiveImages: [this.props.data.imagesSrc[7], this.props.data.imagesSrc[8]],
      bonusSoundPadsImages: [this.props.data.imagesSrc[9], this.props.data.imagesSrc[10], this.props.data.imagesSrc[11], this.props.data.imagesSrc[12], this.props.data.imagesSrc[13], this.props.data.imagesSrc[14], this.props.data.imagesSrc[15], this.props.data.imagesSrc[16]],
      stepsLightsImagesSrc: [this.props.data.imagesSrc[17], this.props.data.imagesSrc[18]],
      stepsLightsVisible: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
      rightOptionsImages: [this.props.data.imagesSrc[19], this.props.data.imagesSrc[20], this.props.data.imagesSrc[21], this.props.data.imagesSrc[22], this.props.data.imagesSrc[23], this.props.data.imagesSrc[24], this.props.data.imagesSrc[25], this.props.data.imagesSrc[26], this.props.data.imagesSrc[27], this.props.data.imagesSrc[28], this.props.data.imagesSrc[29], this.props.data.imagesSrc[30], this.props.data.imagesSrc[31], this.props.data.imagesSrc[32], this.props.data.imagesSrc[33]],
      bottomOptionsImages: [this.props.data.imagesSrc[34], this.props.data.imagesSrc[35], this.props.data.imagesSrc[36], this.props.data.imagesSrc[37], this.props.data.imagesSrc[38], this.props.data.imagesSrc[39], this.props.data.imagesSrc[40], this.props.data.imagesSrc[41], this.props.data.imagesSrc[42], this.props.data.imagesSrc[43], this.props.data.imagesSrc[44], this.props.data.imagesSrc[45], this.props.data.imagesSrc[46], this.props.data.imagesSrc[47], this.props.data.imagesSrc[48], this.props.data.imagesSrc[49]],
      clickBtnPossible : [true, true, true, true, true, true, true, true, true],
      bpm: [250, 375, 500, 625, 750],
      currentBpm: 2,
      justCleared: [
        [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false]
      ],
      data: this.props.data,
      accessKeyPanel: this.props.data.accessKeyPanel,
      soundIdentifierPanel: dataMain.imgSrc[17],
      muteBtnPressed: false,
      clickPossible: true,
    }
    this.handleClick = this.handleClick.bind(this)
    this.handlePointer = this.handlePointer.bind(this)
    this.handleDragEnter = this.handleDragEnter.bind(this)
    this.playSequence = this.playSequence.bind(this)
    this.keyDown = this.keyDown.bind(this)
    this.keyUp = this.keyUp.bind(this)
    this.unloadEventListener = this.unloadEventListener.bind(this)
  }

  componentDidMount() {
    this.loadContent()
    this.loadEventListener()
    this.loadLocalActivePads()
    noContextMenu()
  }

  componentWillUnmount() {
    this.state.audios.forEach(sound => {
      sound.stop()
    })
    this.unloadEventListener()
  }

  loadContent() {
    const pads = document.querySelectorAll('.pad')
    const soundIdentifier = document.querySelector(".sound-identifier")
    this.setState({pads: pads, soundIdentifier: soundIdentifier})
    this.loadSound()
  }

  loadSound() {
    const audios = []

    let kick = new Sound(this.state.data.audios[0], 6);
    let snare = new Sound(this.state.data.audios[1], 6);
    let hihat = new Sound(this.state.data.audios[2], 6);
    let openHihat = new Sound(this.state.data.audios[3], 6);
    let clap = new Sound(this.state.data.audios[4], 6);
    let bell = new Sound(this.state.data.audios[5], 6);
    let bonus1 = new Sound(this.state.data.audios[6], 15);
    let bonus2 = new Sound(this.state.data.audios[7], 15);
    let bonus3 = new Sound(this.state.data.audios[8], 15);
  
    audios.push(kick)
    audios.push(snare)
    audios.push(hihat)
    audios.push(openHihat)
    audios.push(clap)
    audios.push(bell)
    audios.push(bonus1)
    audios.push(bonus2)
    audios.push(bonus3)

    this.setState({audios: audios})
  }

  loadEventListener() {
    window.addEventListener('keydown', this.keyDown)
    window.addEventListener('keyup', this.keyUp)
  }

  keyDown(event) {
    // console.log(event.code)
    let speedReactivation = 0
    let speedReactionArrowAndSpace = 67
    switch(event.code) {
      case "Space": 
        this.actionLimiter(8, '', 'togglePadActive', 250)
        break
        
      case "ArrowLeft":
        this.actionLimiter(5, 'left', 'moveCursor', speedReactionArrowAndSpace)
        break
        
      case "ArrowRight":
        this.actionLimiter(7, 'right', 'moveCursor', speedReactionArrowAndSpace)
        break
      
      case "ArrowUp":
        this.actionLimiter(6, 'up', 'moveCursor', speedReactionArrowAndSpace)
        break
    
      case "ArrowDown":
        this.actionLimiter(4, 'down', 'moveCursor', speedReactionArrowAndSpace)
        break

      case "KeyQ":
        const currentSound = this.state.cursorPosition[0]
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(0, currentSound, 'oneSound', speedReactivation)
        break

      case "KeyW":
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(1, 'pad1', 'bonusSound', speedReactivation)
        break
      
      case "KeyE":
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(2, 'pad2', 'bonusSound', speedReactivation)
        break

      case "KeyR":
        speedReactivation = (1000 - this.state.bpm[this.state.currentBpm])
        this.actionLimiter(3, 'pad3', 'bonusSound', speedReactivation)
        break
        
      case "KeyT":
        this.stopBonus([6, 7, 8], 500)
        break

      case "KeyA":
        if (this.state.currentBpm !== 0) {
          this.changeBpm("minus")
        }
        break

      case "KeyS":
        if (this.state.currentBpm !== 4) {
          this.changeBpm("plus")
        }
        break
      
      case "KeyD":
        this.togglePlay()
        break
          
      case "KeyF":
        this.nftLink()
        break

      case "KeyZ":
        this.reset()
        break

      case "KeyX":
        this.clearActivePads()
        break

      case "KeyC":
        this.clearActiveLine()
        break
      
      case "KeyV":
        if (!this.state.muteBtnPressed) {
          this.mutePads()
        }
        break

      default: break
    }
  }

  keyUp(event) {
    switch(event.code) {
      case "KeyV":
          this.mutePads()
          break

      case "KeyQ":
        this.reactivateAction(0)
        break

      case "KeyW":
        this.reactivateAction(1)
        break
      
      case "KeyE":
        this.reactivateAction(2)
        break

      case "KeyR":
        this.reactivateAction(3)
        break
        
      default: break
    }
  }

  unloadEventListener() {
    window.removeEventListener('keydown', this.keyDown)
    window.removeEventListener('keyup', this.keyUp)
  }

  togglePadActive() {
    const currentContainer = document.getElementById('sekansActivateCursorContainer')
    buttonPressed(currentContainer.children)
    setTimeout(() => buttonPressed(currentContainer.children), 175)

    const row = this.state.cursorPosition[0]
    const column = this.state.cursorPosition[1]

    const activePads = [...this.state.activePads]

    activePads[row][column] = !activePads[row][column]

    this.setState({activePads: activePads}, () => {
      this.saveActivePads()
    })
  }

  moveCursor(moveTo) {
    const cursorX = this.state.cursorPosition[1]
    const cursorY = this.state.cursorPosition[0]
    const stepsAmount = this.state.stepsAmount
    const soundsAmount = this.state.soundsAmount

    let currentContainer = ''
    
    switch(moveTo) {
      case "left":
        currentContainer = document.getElementById('sekansLeftArrowContainer')
        buttonPressed(currentContainer.children)
        setTimeout(() => buttonPressed(currentContainer.children), 175)

        let xLeft = cursorX - 1
        if (xLeft < 0) xLeft = 0
        this.updateCursorPosition(cursorY, xLeft)
        break

      case "right":
        currentContainer = document.getElementById('sekansRightArrowContainer')
        buttonPressed(currentContainer.children)
        setTimeout(() => buttonPressed(currentContainer.children), 175)
        let xRight = cursorX + 1
        if (xRight > stepsAmount - 1) xRight = stepsAmount - 1
        this.updateCursorPosition(cursorY, xRight)
        break

      case "up":
        currentContainer = document.getElementById('sekansUpArrowContainer')
        buttonPressed(currentContainer.children)
        setTimeout(() => buttonPressed(currentContainer.children), 175)
        let yUp = cursorY - 1
        if (yUp < 0) yUp = 0
        this.updateCursorPosition(yUp, cursorX)
        break

      case "down":
        currentContainer = document.getElementById('sekansDownArrowContainer')
        buttonPressed(currentContainer.children)
        setTimeout(() => buttonPressed(currentContainer.children), 175)
        let yDown = cursorY + 1
        if (yDown > soundsAmount - 1) yDown = soundsAmount - 1
        this.updateCursorPosition(yDown, cursorX)
        break

      default: break
    }
  }

  updateCursorPosition(y, x) {
    const activeCursor = this.updateActiveCursor(x, y, this.state.cursorPosition[0], this.state.cursorPosition[1])

    this.setState({cursorPosition: [y, x], activeCursor: activeCursor})
  }

  updateActiveCursor(x, y, lastPositionY, lastPositionX){
    const activeCursor = [...this.state.activeCursor]

    activeCursor[lastPositionY][lastPositionX] = !activeCursor[lastPositionY][lastPositionX]

    activeCursor[y][x] = true

    return activeCursor
  }

  async fetchOpenSea() {
    const result = await retrieveOwner(this.state.data.contractAdress, this.state.data.tokenId)
    const owner = result.top_ownerships[0].owner.user.username
    const ownerAddress = result.top_ownerships[0].owner.address
    this.setState({owner: owner, ownerAddress: ownerAddress})
  }

  handleClick(event) {
    if (this.state.clickPossible) {
      if(event.target.dataset.action === undefined) {
        let parent = event.target.parentElement
        while(parent.dataset.action === undefined) {
          parent = parent.parentElement
        }
        // console.log(parent)
        switch(parent.dataset.action) { 
          case "moveCursor": 
            parent.blur()
            this.moveCursor(parent.dataset.type)
            break

          case "playBonus": 
            parent.blur()
            this.playBonus(parent.dataset.type)
            break

          case "stopBonus":
            this.stopBonus([6, 7, 8])
            break

          case "activateCursor": 
            this.togglePadActive()
            break

          case "changeBpm":
            switch(parent.dataset.type) {
              case "minus":
                if (this.state.currentBpm !== 0) {
                  this.changeBpm("minus")
                }
                break
  
              case "plus":
                if (this.state.currentBpm !== 4) {
                  this.changeBpm("plus")
                }
                break
  
              default: break
            }
            break

          case "playStop":
            this.togglePlay()
            break

          case "nftLink":
            this.nftLink()
            break

          case "reset":
            this.reset()
            break

          case "clear":
            this.clearActivePads()
            break

          case "clearLine":
            this.clearActiveLine()
            break

          case "mute":
            this.mutePads()
            break

          case "playCurrentSound":
            const currentSound = this.state.cursorPosition[0]
            this.playOneSound(currentSound)
            break
    
          default: break
        }
      }
      else {
        // console.log(event.target)
        switch(event.target.dataset.action) {
          case "togglePadStatus": 
            event.target.blur()
            this.activatePad(event.target)
            break

          default: break
        }
      }
    }
  }

  handlePointer(event) {
    const clickPossible = false
    this.setState({clickPossible: clickPossible}, () => {
      if(event.target.dataset.action === undefined) {
        let parent = event.target.parentElement
        while(parent.dataset.action === undefined) {
          parent = parent.parentElement
        }
        // console.log(parent)
        switch(parent.dataset.action) { 
          case "playBonus": 
            event.target.blur()
            this.playBonus(parent.dataset.type)
            break
          
          case "stopBonus":
            event.target.blur()
            this.stopBonus([6, 7, 8])
            break
            
          default: break
        }
      }
      else {
        switch(event.target.dataset.action) {
          case "togglePadStatus": 
            event.target.blur()
            this.activatePad(event.target)
            break
  
          default: break
        }
      }

      setTimeout(() => {
        const clickPossible = true
        this.setState({clickPossible: clickPossible}, () => {
        })
      }, 500)
    })
  }

  handleDragEnter(event) {
    // console.log(event.target)
    switch(event.target.dataset.action) {
      case "togglePadStatus": 
      event.target.blur()
        this.activatePad(event.target)
        break

      default: break
    }
  }

  activatePad(pad) {
    const row = pad.dataset.row - 1
    const col = pad.dataset.col - 1

    const activePads = [...this.state.activePads]

    activePads[row][col] = !activePads[row][col]

    this.updateCursorPosition(row, col)

    this.setState({activePads: activePads}, () => {
      this.saveActivePads()
    })
  }

  togglePlay() {
    const currentContainer = document.getElementById('sekansPlayStopContainer')
    buttonPressed(currentContainer.children)

    this.setState(prevState => {
      return ({playActive: !prevState.playActive})
    }, () => {
      this.verifyPlaying()
    })
  }

  verifyPlaying() {
    if (this.state.playActive) {
      const vitesse = ((1000 * 60) / this.state.bpm[this.state.currentBpm])
      playIntervale = setInterval(this.playSequence, vitesse)
    }
    else {
      clearInterval(playIntervale)
      this.setState({currentStep: -1}, this.updatePosition)
    }
  }

  updatePosition() {
    const stepsLightsVisible = [...this.state.stepsLightsVisible]

    for (let i = 0; i < stepsLightsVisible.length; i++) {
      stepsLightsVisible[i] = false
    }
    this.setState({stepsLightsVisible: stepsLightsVisible})
  }

  playSequence() {
    this.setState(prevState => {
      return ({currentStep: prevState.currentStep + 1})
    }, () => {
      this.showPosition()
      if (!this.state.mutePads) this.playSound()
    })
  }

  showPosition() {
    const stepsLightsVisible = [...this.state.stepsLightsVisible]
    const currentStep = this.state.currentStep % this.state.stepsAmount
    let lastStep = (this.state.currentStep - 1) % this.state.stepsAmount

    if (lastStep !== -1) {
      stepsLightsVisible[lastStep] = !stepsLightsVisible[lastStep]
    }

    stepsLightsVisible[currentStep] = !stepsLightsVisible[currentStep]

    this.setState({stepsLightsVisible: stepsLightsVisible})
  }

  playSound() {
    const currentStep = this.state.currentStep % this.state.stepsAmount
    const activePads = this.state.activePads
    
    const audios = this.state.audios

    const playSoundsArr = activePads.map(item => {
      return item[currentStep]
    })

    playSoundsArr.forEach((sound, index) => {
      if (sound) audios[index].play()
    })
  }

  playOneSound(index) {
    const sound = this.state.audios[index]
    sound.stop()
    sound.play()
  }

  playBonus(type) {
    let currentContainer = ''
    
    switch(type) {
      case "pad1":
        currentContainer = document.getElementById('bonusSoundPad1Container')
        this.state.audios[6].stop()
        this.state.audios[7].stop()
        this.state.audios[8].stop()
        this.playOneSound(6)
        break

      case "pad2":
        currentContainer = document.getElementById('bonusSoundPad2Container')
        this.state.audios[6].stop()
        this.state.audios[7].stop()
        this.state.audios[8].stop()
        this.playOneSound(7)
        break

      case "pad3":
        currentContainer = document.getElementById('bonusSoundPad3Container')
        this.state.audios[6].stop()
        this.state.audios[7].stop()
        this.state.audios[8].stop()
        this.playOneSound(8)
        break

      default: break
    }
  
    buttonPressed(currentContainer.children)
    setTimeout(() => buttonPressed(currentContainer.children), 175)
  }
  
  stopBonus(indexArr) {
    const currentContainer = document.getElementById('bonusSoundsStopContainer')
    buttonPressed(currentContainer.children)
    setTimeout(() => buttonPressed(currentContainer.children), 175)
    
    const audios = this.state.audios

    indexArr.forEach(index => {
      audios[index].stop()
    })
  }

  changeBpm(type) {
    let currentBpm = this.state.currentBpm
    let currentContainer = ''

    switch(type) {
      case "minus": 
        currentContainer = document.getElementById('sekansBpmMinusContainer')
        buttonPressed(currentContainer.children)
        setTimeout(() => buttonPressed(currentContainer.children), 175)
        currentBpm--
        break
      
      case "plus":
        currentContainer = document.getElementById('sekansBpmPlusContainer')
        buttonPressed(currentContainer.children)
        setTimeout(() => buttonPressed(currentContainer.children), 175)
        currentBpm++
        break
      
      default: break
    }

    this.setState({currentBpm: currentBpm}, () => {
      if (this.state.playActive) {
        clearInterval(playIntervale)
        const vitesse = ((1000 * 60) / this.state.bpm[this.state.currentBpm])
        playIntervale = setInterval(this.playSequence, vitesse)
      }
    })
  }
  
  clearActivePads() {
    const currentContainer = document.getElementById('sekansClearContainer')
    buttonPressed(currentContainer.children)
    setTimeout(() => buttonPressed(currentContainer.children), 175)

    const activePads = [
      [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
      [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false]
    ]

    const justCleared = [
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
    ]

    setTimeout(() => {
      const justCleared = [
        [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
        [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],[false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false]
      ]

      this.setState({justCleared: justCleared})
    }, 300)

    this.setState({activePads: activePads, justCleared: justCleared}, () => {
      this.saveActivePads()
    })
  }

  clearActiveLine() {
    const currentContainer = document.getElementById('sekansClearLineContainer')
    buttonPressed(currentContainer.children)
    setTimeout(() => buttonPressed(currentContainer.children), 175)

    const currentSound = this.state.cursorPosition[0]

    const activePads = [...this.state.activePads]

    activePads[currentSound] = [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false]

    const justCleared = [...this.state.justCleared]
    justCleared[currentSound] = [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true]

    setTimeout(() => {
      const justCleared = [...this.state.justCleared]
      justCleared[currentSound] = [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false]

      this.setState({justCleared: justCleared})
    }, 300)

    this.setState({activePads: activePads, justCleared: justCleared}, () => {
      this.saveActivePads()
    })
  }

  mutePads() {
    const currentContainer = document.getElementById('sekansMuteContainer')
    buttonPressed(currentContainer.children)

    const mutePads = !this.state.mutePads
    const muteBtnPressed = !this.state.muteBtnPressed

    this.setState({mutePads: mutePads, muteBtnPressed: muteBtnPressed})
  }

  reset() {
    const currentContainer = document.getElementById('sekansResetContainer')
    
    setTimeout(() => {
      buttonPressed(currentContainer.children)
      window.location.reload()
    }, 175)
  }

  nftLink() {
    const currentContainer = document.getElementById('sekansNftLinkContainer')
    buttonPressed(currentContainer.children)

    const path = this.state.data.nftPath
    setTimeout(() => {
      buttonPressed(currentContainer.children)
      goToNftPath(path)
    }, 175)
  }

  loadLocalActivePads() {
    const model = this.props.data.model
    const edition = this.props.data.edition
    const dataToLoad = `${model}.${edition}`

    const localDataLoaded = localStorage.getItem(dataToLoad)

    const data = JSON.parse(localDataLoaded)
    
    if (localDataLoaded !== null) {
      this.setState({activePads: data})
    }
  }

  saveActivePads() {
    const model = this.props.data.model
    const edition = this.props.data.edition
    const dataToSave = `${model}.${edition}`

    const activePads = this.state.activePads

    localStorage.setItem(dataToSave, JSON.stringify(activePads))
  }

  actionLimiter(clickPossibleIndex, functionParam, action, speedReactivation) { 
    if (this.state.clickBtnPossible[clickPossibleIndex]) {
      const clickBtnPossible = [...this.state.clickBtnPossible]
      clickBtnPossible[clickPossibleIndex] = false
      this.setState({clickBtnPossible: clickBtnPossible}, () => {
        switch(action) {
          case "oneSound": 
            this.playOneSound(functionParam)
            break

          case "bonusSound": 
            this.playBonus(functionParam)
            break 

          case "moveCursor": 
            this.moveCursor(functionParam)
            break 

          case "togglePadActive": 
            this.togglePadActive()
            break 

          default: break
        }
        
        setTimeout(() => {
          const clickBtnPossible = [...this.state.clickBtnPossible]
          clickBtnPossible[clickPossibleIndex] = true
          this.setState({clickBtnPossible: clickBtnPossible})
        }, speedReactivation)
      })
    }
  }

  reactivateAction(clickPossibleIndex) {
    const clickBtnPossible = [...this.state.clickBtnPossible]
    clickBtnPossible[clickPossibleIndex] = true
    this.setState({clickBtnPossible: clickBtnPossible})
  }

  render() {
    return(
      <div id="container-MPT" style={{height: this.props.height, width: this.props.width}}>
        <img draggable="false" id="sekansFrameImg" className="noContextMenu" src={this.state.imagesSrc[0]} alt="MPT sekansPrototype" />

        <SekansSoundsIdentifier cursorPadActiveImages={this.state.cursorPadActiveImages} activePads={this.state.activePads} cursorPosition={this.state.cursorPosition} soundsIdentifiersImages={this.state.soundsIdentifiersImages} handleClick={this.handleClick} />
        <SekansBonusSounds bonusSoundPadsImages={this.state.bonusSoundPadsImages} handleClick={this.handleClick} handlePointer={this.handlePointer} />
        <SekansStepsLights stepsLightsVisible={this.state.stepsLightsVisible} stepsLightsImagesSrc={this.state.stepsLightsImagesSrc} />
        <SekansPadsCard activePads={this.state.activePads} padsIndexes={this.state.padsIndexes} activeCursor={this.state.activeCursor} handleClick={this.handleClick} justCleared={this.state.justCleared} handlePointer={this.handlePointer} handleDragEnter={this.handleDragEnter} edition={this.state.data.edition} />
        
        <SekansRightOptions rightOptionsImages={this.state.rightOptionsImages} currentBpm={this.state.currentBpm} handleClick={this.handleClick} />
        <SekansBottomOptions bottomOptionsImages={this.state.bottomOptionsImages} handleClick={this.handleClick} />
      </div>
    )
  }
}